// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ModuleType,
} from "./types";

export default {
  projectName: __t.string(),
  get moduleType() {
    return ModuleType;
  },
  success: __t.bool(),
  wasmHash: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
};
